export default __webpack_public_path__ + "static/media/step-5.7b2bb2cf.mp4";